// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.yj-data-empty[data-v-3a7f8c73] {\n  text-align: center;\n}\n.empty-text[data-v-3a7f8c73] {\n  margin: 20px 0 30px 0;\n  color: #999;\n}\n", ""]);
// Exports
module.exports = exports;
